import request from '@/utils/request';

// 设备报表
export const getDeptSerPriceStatistics = (params: any) =>
  request({
    url: 'StatisticsDeptSerPrice/price',
    method: 'get',
    params
  });

// 导出excel 设备列表
export const exportDeptSerPriceStatistics = (params: any) =>
  request({
    url: 'StatisticsDeptSerPrice/export',
    method: 'get',
    params
  });
